export interface IState {
	errorCode: number;
	errorMessage: string;
	paymentRun: IPaymentRunState;
	paymentDetails: IPaymentDetails;
}

export const PAGE_LIMIT = 8;

export enum PaymentDetailsType {
	EOP = 'EOP',
	GROUP_INVOICE = 'GROUP_INVOICE',
	ASSESSMENT_FEE = 'ASSESSMENT_FEE',
}

export interface IPaymentClaimShort {
	claimUUID: number | string;
	externalClaimId: string;
	invoiceNumber: string;
	totalAmountPaid: number;
	assessmentFee: number;
	assessmentFeeVat: number;
}

export interface IPaymentClaim {
	claimUUID: string;
	externalClaimId: string;
	dateOfService: string;
	location: string;
	totalCharges: number;
	contractualWriteOff: number;
	memberResponsible: number;
	claimPayment: number;
	assessmentFee: number;
	assessmentFeeTax: number;
	other: number;
	netDue: number;
	retailNetOfTax: number;
	tax: number;
	eyemedFee: number;
	pswtAmount: number;
}

export interface IPaymentRunState {
	claims: IPaymentClaimShort[];
	pages: number;
	page: number;
	paymentRunDate: string;
	paymentRunId: string;
	totalAmount: number;
}

interface IPaymentDetails {
	paymentRunDate: string;
	paymentRunId: string;
	detailType: string;
	from: {
		address: string;
		city: string;
		companyDescription: string;
		country: string;
		name: string;
		tin: string;
		street: string;
		region: string;
		postalCode: string;
		shareCapital: string;
	};
	to: {
		address: string;
		city: string;
		companyDescription: string;
		country: string;
		name: string;
		tin: string;
		street: string;
		region: string;
		postalCode: string;
		shareCapital: string;
	};
	paymentInfo: {
		invoiceDate: string;
		invoiceNumber: string;
		typeOfService: string;
		paymentTerms: string;
		service: string;
		quantity: 0;
		description: string;
		expiryDate: string;
		vatDescription: string;
	};
	paymentAmount: {
		paymentId: string;
		unitPrice: number;
		amount: number;
		subTotal: number;
		vat: number;
		total: number;
	};
	paymentClaims: IPaymentClaim[];
	total: {
		claimUUID: string;
		dateOfService: string;
		location: string;
		totalCharges: number;
		retailNetOfTax: number;
		contractualWriteOff: number;
		memberResponsible: number;
		claimPayment: number;
		assessmentFee: number;
		assessmentFeeTax: number;
		other: number;
		netDue: number;
		tax: number;
		eyemedFee: number;
		pswtAmount: number;
	};
}
export interface IPaymentRunThunkProps {
	id: string;
}
export interface IPaymentDetailsThunkProps {
	paymentRunId: string;
	detailType: string;
}

export interface IPaymentFeeThunkProps {
	claimUUID: string;
}
